import axios from "axios";

/**
 * Upload a single file to Cloudinary.
 * Returns the Cloudinary URL or throws an error.
 * 
 * @param {File} file - The file to upload.
 * @param {string} cloudName - The Cloudinary cloud name.
 * @param {string} uploadPreset - The Cloudinary upload preset.
 * @returns {Promise<string>} - The secure URL of the uploaded file.
 */
export async function uploadToCloudinary(file, cloudName = "dzngpgki4", uploadPreset = "adluck") {
  const url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", uploadPreset);

  try {
    const res = await axios.post(url, formData);
    return res.data.secure_url; // Successfully uploaded, return the URL
  } catch (error) {
    console.error("Error uploading to Cloudinary:", error);
    throw new Error("Failed to upload file to Cloudinary.");
  }
}

/**
 * Upload multiple files to Cloudinary.
 * Returns an array of URLs or throws an error for any failed uploads.
 * 
 * @param {File[] | FileList} files - The files to upload.
 * @param {string} cloudName - The Cloudinary cloud name.
 * @param {string} uploadPreset - The Cloudinary upload preset.
 * @returns {Promise<string[]>} - An array of secure URLs of the uploaded files.
 */
export async function uploadMultipleToCloudinary(files, cloudName = "dzngpgki4", uploadPreset = "adluck") {
  if (!files || files.length === 0) return [];
  try {
    const uploads = Array.from(files).map(file =>
      uploadToCloudinary(file, cloudName, uploadPreset)
    );
    return await Promise.all(uploads);
  } catch (error) {
    console.error("Error uploading multiple files to Cloudinary:", error);
    throw new Error("Failed to upload multiple files to Cloudinary.");
  }
}